import request from '@/utils/request'

export const getGlPostingFailures = () => request.get('/accounting/gl-posting-failures')

export const retryGlPostingFailure = id => request.post(`/accounting/gl-posting-failures/${id}/retry`)
